import { COMMON_COUNTRY } from '../enum/commonCountry'
let typeWindow = typeof window !== 'undefined'
//税号资料路由
const taxInfoList = [
  { country: '3', routerName: 'TaxNumberInformation' },
  { country: '1', routerName: 'FrenchTaxNumber' },
  { country: '4', routerName: 'SpainTaxNunber' },
  { country: '8', routerName: 'AustriaTaxNumber' },
  { country: '5', routerName: 'polandTaxNumber' },
  { country: '6', routerName: 'CzechTaxNumber' },
  { country: '7', routerName: 'NetherTaxNumber' },
  { country: '11', routerName: 'SaudiTaxNumber' },
  { country: '12', routerName: 'unitedArabEmiratesTaxNumber' }
]

///epr查看资料路由
const eprInfoList = [
  { eprType: '2', routerName: 'packingManageDetail' },
  { eprType: '3', routerName: 'batteryManageDetail' },
  { eprType: '4', routerName: 'spinManageDetail' },
  { eprType: '5', routerName: 'furnitureManageDetail' }
]
///epr查看资料路由
const toLongTimeList = [
  {
    value: '至长期',
    label: typeWindow && window?.app?.$t ? window.app.$t('remote.common.toTheLongTerm') : '',
  },
  { value: '', label: '' }
]

// 文员服务资料税号资料跳转
const routerClerkList = [
  { taxCountry: '1', routerName: 'TaxComDetailFranceClerk' },
  { taxCountry: '2', routerName: 'TaxComDetailGermanyClerk' },
  { taxCountry: '3', routerName: 'TaxComDetailItalyClerk' },
  { taxCountry: '4', routerName: 'TaxComDetailSpan' },
  { taxCountry: '5', routerName: 'TaxComDetailpoland' },
  { taxCountry: '6', routerName: 'TaxComDetailCzech' },
  { taxCountry: '7', routerName: 'TaxComDetailNether' },
  { taxCountry: '8', routerName: 'TaxComDetailAustria' },
  { taxCountry: '11', routerName: 'TaxComDetailSaudi' },
  { taxCountry: '12', routerName: 'TaxComDetailUAE' },
  { taxCountry: '34', routerName: 'TaxComDetailMexico' },
  { taxCountry: '99', routerName: 'TaxComDetailIoss' },
  { taxCountry: '100', routerName: 'TaxComDetailJapan' }
]

const taxVatRouterList = [
  { taxCountry: '1', name: 'TaxComDetailFrance' },
  { taxCountry: '2', name: 'TaxComDetailGermany' },
  { taxCountry: '3', name: 'TaxComDetailItaly' },
  { taxCountry: '4', name: 'TaxComDetailSpan' },
  { taxCountry: '8', name: 'TaxComDetailAustria' },
  { taxCountry: '5', name: 'TaxComDetailpoland' },
  { taxCountry: '6', name: 'TaxComDetailCzech' },
  { taxCountry: '7', name: 'TaxComDetailNether' },
  { taxCountry: '11', name: 'TaxComDetailSaudi' },
  { taxCountry: '12', name: 'TaxComDetailUAE' },
  { taxCountry: '34', name: 'TaxComDetailMexico' },
  { taxCountry: '99', name: 'TaxComDetailIoss' },
  { taxCountry: '100', name: 'TaxComDetailJapan' }
]

const EPR_SERVICE_BUSINESS_TYPE = {
  WEEE: 1, //WEEE
  PACKAGING: 2, //包装法
  BATTERY: 3, //电池法
  SPINNING: 4, // 纺织法
  FURNITURE: 5, // 家具法
  TOYS: 6, // 玩具法
  PLASTIC: 7, // 塑料税
  TYRE: 8, // 轮胎法
  PAPER: 9, // 纸张法
  SPORTS: 10, // 体育和休闲运动
  DIY_GARDEN: 11 // DIY和园艺工具
}

const EPR_COUNTRY_LIST = {
  // 英国
  [COMMON_COUNTRY.GB]: {
    [EPR_SERVICE_BUSINESS_TYPE.WEEE]: 'weeeManageDetailEngland',
    [EPR_SERVICE_BUSINESS_TYPE.PLASTIC]: 'plasticManageDetailGERmany',
  },
  // 法国
  [COMMON_COUNTRY.FR]: {
    [EPR_SERVICE_BUSINESS_TYPE.WEEE]: 'weeeManageDetailFrance',
    [EPR_SERVICE_BUSINESS_TYPE.PACKAGING]: 'packingManageDetailFrance',
    [EPR_SERVICE_BUSINESS_TYPE.BATTERY]: 'batteryManageDetailFrance',
    [EPR_SERVICE_BUSINESS_TYPE.SPINNING]: 'spinningManageDetailFrance',
    [EPR_SERVICE_BUSINESS_TYPE.FURNITURE]: 'furnitureManageDetailFrance',
    [EPR_SERVICE_BUSINESS_TYPE.TOYS]: 'toysManageDetailFrance',
    [EPR_SERVICE_BUSINESS_TYPE.TYRE]: 'tyreManageDetailFrance',
    [EPR_SERVICE_BUSINESS_TYPE.PAPER]: 'paperManageDetailFrance',
    [EPR_SERVICE_BUSINESS_TYPE.SPORTS]: 'sportsManageDetailFrance',
    [EPR_SERVICE_BUSINESS_TYPE.DIY_GARDEN]: 'diyGardenManageDetailFrance',
  },
  // 德国
  [COMMON_COUNTRY.DE]: {
    [EPR_SERVICE_BUSINESS_TYPE.WEEE]: 'weeeManageDetailGermany',
    [EPR_SERVICE_BUSINESS_TYPE.PACKAGING]: 'packingManageDetailGermany',
    [EPR_SERVICE_BUSINESS_TYPE.BATTERY]: 'batteryManageDetailGermany',
    [EPR_SERVICE_BUSINESS_TYPE.PLASTIC]: 'commonMultipleCategoriesDetailS',
  },
  // 意大利
  [COMMON_COUNTRY.IT]: {
    [EPR_SERVICE_BUSINESS_TYPE.WEEE]: 'weeeManageDetailItaly',
    [EPR_SERVICE_BUSINESS_TYPE.PACKAGING]: 'packingManageDetailItaly',
    [EPR_SERVICE_BUSINESS_TYPE.BATTERY]: 'batteryManageDetailItaly',
  },
  // 西班牙
  [COMMON_COUNTRY.ES]: {
    [EPR_SERVICE_BUSINESS_TYPE.WEEE]: 'weeeManageDetailSpain',
    [EPR_SERVICE_BUSINESS_TYPE.PACKAGING]: 'packingManageDetailSPain',
    [EPR_SERVICE_BUSINESS_TYPE.BATTERY]: 'batteryManageDetailSpain',
  },
  // 奥地利
  [COMMON_COUNTRY.AT]: {
    [EPR_SERVICE_BUSINESS_TYPE.WEEE]: 'weeeManageDetailAustria',
    [EPR_SERVICE_BUSINESS_TYPE.PACKAGING]: 'packingManageDetailAustria',
    [EPR_SERVICE_BUSINESS_TYPE.BATTERY]: 'batteryManageDetailAustria',
  },
  // 瑞典
  [COMMON_COUNTRY.SE]: {
    [EPR_SERVICE_BUSINESS_TYPE.PACKAGING]: 'packingManageDetailSweden',
    [EPR_SERVICE_BUSINESS_TYPE.BATTERY]: 'commonMultipleCategoriesDetailS',
    [EPR_SERVICE_BUSINESS_TYPE.WEEE]: 'commonMultipleCategoriesDetailS',
  },
  // 荷兰
  [COMMON_COUNTRY.NL]: {
    [EPR_SERVICE_BUSINESS_TYPE.BATTERY]: 'batteryManageDetailNetherlands',
  },
  // 波兰
  [COMMON_COUNTRY.PL]: {
    [EPR_SERVICE_BUSINESS_TYPE.BATTERY]: 'commonMultipleCategoriesDetailS',
    [EPR_SERVICE_BUSINESS_TYPE.WEEE]: 'weeeManageDetailPoland',
    // batteryManageDetailPoland
  },
  // 爱尔兰
  [COMMON_COUNTRY.IE]: {
    [EPR_SERVICE_BUSINESS_TYPE.BATTERY]: 'batteryManageDetailIreland',
    [EPR_SERVICE_BUSINESS_TYPE.WEEE]: 'weeeManageDetailIreland',
    // batteryManageDetailPoland
  },
  // 丹麦
  [COMMON_COUNTRY.DK]: {
    [EPR_SERVICE_BUSINESS_TYPE.PACKAGING]: 'DKPackingManageDetail',
    [EPR_SERVICE_BUSINESS_TYPE.BATTERY]: 'DKBatteryManageDetail',
    [EPR_SERVICE_BUSINESS_TYPE.WEEE]: 'DKWEEEManageDetail',
    // batteryManageDetailPoland
  },
}

const VAT_COUNTRY_LIST = {
  [COMMON_COUNTRY.SA]: 'TaxComDetailSaudi', // 沙特
  [COMMON_COUNTRY.UAE]: 'TaxComDetailUAE', // 阿联酋
  [COMMON_COUNTRY.CZ]: 'TaxComDetailCzech', // 捷克
  [COMMON_COUNTRY.GB]: 'TaxInfoDetailEngland', // 英国
  [COMMON_COUNTRY.PL]: 'TaxComDetailpoland', // 波兰
  [COMMON_COUNTRY.AT]: 'TaxComDetailAustria', // 奥地利
  [COMMON_COUNTRY.DE]: 'TaxComDetailGermany', // 德国
  [COMMON_COUNTRY.AU]: 'TaxComDetailAustraliaGST', // 澳大利亚GST
  [COMMON_COUNTRY.MX]: 'TaxComDetailMexico', // 澳大利亚GST
  [COMMON_COUNTRY.IE]: 'TaxComDetailIrland', // 爱尔兰
}
// 瓦太组件100%宽度
const allRowComponent = [
  'powerOfAttorney',
  'powerOfAttorney2',
  'commonUpload',
  'submitFileView',
  'commonUploadConcatFile',
  'fileUpload',
  'pictureAndFileUpload',
  'animationDownData',
  'UploadTaxauthorization',
  'supplementShopAllPlatform',
  'supplementASINAllPlatform',
  'OtherEUCountryTaxCode',
  'authorizedProductInformation',
  'commonTable',
  'quotaFormTable',
  'deBatteryProductInformation',
  'deBatteryProductInfoNew',
  'deBatteryMarketWeightTable',
  'TyreSaleTable',
  'mexicoShareholder',
  'commonUploadConcatFile',
  'deWEEEProductInformation',
  'AnnualSaleDataReport',
  'multifileUpload',
  'EsBatteryProductInfo',
  'EsW3eProductInfoMultiCategory',
  'EsW3eProductInfo',
  'deWEEEProductInformationOld',
  'faCDProductInformation',
  'euDocProductInformation',
  'checkStatement',
  'frWeeeQuotaFormTable',
  'frBatteryQuotaFormTable',
  'supplementShopNew',
  'JapanSupplementASINAllPlatform'
]
// 所有服务资料页面，根据路由判断是否展示操作指引
const allServiceInformation = [
  'customDataOrder',
  'newApplicationFromBritain',
  'newTransferFromBritain',
  'newApplicationFromGermany',
  'newTransferFromGermany',
  'newFranceRevision',
  'newFranceTransfer',
  'newApplicationFromItaly',
  'newTransferFromItaly',
  'AustriaRegistrations',
  'polandTransfers',
  'CzechNewApplication',
  'CzechNewTransfer',
  'SpainRegistrationNoHague',
  'polandTransfer',
  'newApplicationFromIoss',
  'weeeDetail',
  'packingDetail',
  'FancePackingDetail',
  'FanceBatteryDetail',
  'BatteryRegistrations',
  'odeiDetail',
  'packingTransferDetail',
  'weeeAddDetail',
  'packingAddDetail',
  'batteryAddBrand',
  'toLongTimeList',
  'eoriServiceApplication',
]

export { allRowComponent, taxInfoList, eprInfoList, routerClerkList, taxVatRouterList, EPR_SERVICE_BUSINESS_TYPE, EPR_COUNTRY_LIST, VAT_COUNTRY_LIST, allServiceInformation }



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/common/material.js